import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useContext, useState } from 'react';
import { SettingCard } from 'z3k-settings/components/material-utils/settings-card';
import { Control } from 'shared/components/fields/control';
import { TextInputWrapper } from 'shared/components/fields/text';
import { ErrorBoundary } from 'console/shared/components/error-boundary';
import { Z3KSettingsEditor } from 'z3k-settings/provider/types';
import { useBox } from 'shared/hooks/utils';
export const SettingsConnectionMQTT = memo(function SettingsConnectionMQTT() {
    const { config, replace_config } = useContext(Z3KSettingsEditor);
    const [address, setAddress] = useState(config.mqtt_address ?? '');
    const configBox = useBox(config);
    const onChangeMqttAddress = useCallback((value) => {
        replace_config({ ...configBox.current, mqtt_address: value });
        setAddress(value);
    }, []);
    return (_jsx(ErrorBoundary, { children: _jsx(SettingCard, { title: "\u0410\u0434\u0440\u0435\u0441 \u0441\u0435\u0440\u0432\u0435\u0440\u0430 MQTT", container_props: { display: 'flex' }, children: _jsx(Control, { label: "\u0410\u0434\u0440\u0435\u0441", field: TextInputWrapper, help_id: null, value: address, onChange: onChangeMqttAddress, validation_result: null, validation_warnings_result: null }) }) }));
});
